import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

const GlobalMenuItem = ({ route, text }) => (
  <Link to={route} target={route === "/powerbi" && "_blank"} rel={route === "/powerbi" && "opener"} className="link-button">
    <ListItem button className="menu-item">
      <ListItemText primary={text} className="menu-text" />
    </ListItem>
  </Link>
);

GlobalMenuItem.propTypes = {
  route: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
};

export default GlobalMenuItem;
